
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class OrderManagementCheckListDialog extends Serenity.EntityDialog<OrderManagementCheckListRow, any> {
        protected getFormKey() { return OrderManagementCheckListForm.formKey; }
        protected getIdProperty() { return OrderManagementCheckListRow.idProperty; }
        protected getLocalTextPrefix() { return OrderManagementCheckListRow.localTextPrefix; }
        protected getService() { return OrderManagementCheckListService.baseUrl; }
        protected getDeletePermission() { return OrderManagementCheckListRow.deletePermission; }
        protected getInsertPermission() { return OrderManagementCheckListRow.insertPermission; }
        protected getUpdatePermission() { return OrderManagementCheckListRow.updatePermission; }

        protected form = new OrderManagementCheckListForm(this.idPrefix);

    }
}